export enum LocationType {
    Onsite = 'ONSITE',
    Remote = 'REMOTE',
    Hybrid = 'HYBRID'
}
